// extracted by mini-css-extract-plugin
export default {"heading":"iw-z","corrected":"jw-z","redirectVerbiageContainer":"kw-z","redirectVerbiageText":"lw-z"};